import { render, staticRenderFns } from "./InterfaceSetting.vue?vue&type=template&id=3b21c49e"
import script from "./InterfaceSetting.js?vue&type=script&lang=js&external"
export * from "./InterfaceSetting.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports